import React from 'react';
import { Box, VStack, Spinner, Text, Heading, useColorModeValue } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const Loading = () => {
  // Soft floating animation for the logo
  const float = keyframes`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-6px); }
  `;

  // Dynamic background and text color based on color mode
  const bgGradient = useColorModeValue(
    'linear(to-b, brand.tealSoft, white)',
    'linear(to-b, gray.900, gray.800)'
  );
  const textColor = useColorModeValue('brand.navy', 'teal.200');

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgGradient={bgGradient}
      px={4}
    >
      <VStack spacing={6} textAlign="center">
        {/* Animated Brand Title */}
        <Heading
          as="h1"
          size="2xl"
          fontWeight="bold"
          color={textColor}
          animation={`${float} 2.5s ease-in-out infinite`}
        >
          FinanSee
        </Heading>

        {/* Spinner */}
        <Spinner
          thickness="4px"
          speed="0.75s"
          emptyColor="gray.200"
          color="brand.teal"
          size="xl"
        />

        {/* Loading Text */}
        <Text
          fontSize="lg"
          color={useColorModeValue('gray.600', 'gray.300')}
          fontWeight="medium"
        >
          Preparing your personalized insights...
        </Text>
      </VStack>
    </Box>
  );
};

export default Loading;
